import React, { Component } from 'react';
import styled from 'styled-components';
import Section from './Section';
import { device } from '../utils/devices';

const Table = styled.div`
  padding: 10vw;
  font-size: 24px;
  text-align: center;

  background: #FFFBFB;

  @media ${device.laptop} {
    font-size: 30px;
    grid-template-columns: 1fr 1fr 1fr;
    display: grid;
    padding: 4rem;
    direction: ltr;
  }

  h2 {
    font-size: 24px
    font-weight: 200;

    @media ${device.laptop} {
      font-size: 30px;
    }
  }

  strong {
    font-weight: 400;
  }

  small {
    font-size: 16px;
  }

  div {
    text-align: center;
    border-bottom: 1px solid ${props => props.theme.bg}
    margin-bottom: 3rem;
    padding-bottom: 2rem;

    @media ${device.laptop} {
      border: 0;
      margin: 0;
      padding: 0;
    }

    &:last-of-type {
      grid-column: 1/3;
      border: 0;
      margin-top: 2rem;
      text-align: left;

      p {
        display: flex;
        justify-content: space-between;

        span {
          flex-grow: 1;
          margin: 0 1rem;
          display: block;
          background-image: linear-gradient(to right, black 33%, rgba(255,255,255,0) 0%);
          background-position: bottom;
          background-size: 4px 1px;
          background-repeat: repeat-x;
        }
      }
    }
  }
`;

export default class Pricing extends Component {
  render(){
    return (
      <Section title='Pricing' left={this.props.left}>
        <Table>
          <div>
            <p>3 months*</p>
            <p><strong>$750 per month</strong></p>
            <small>*3 full shoot days per month</small>
          </div>
          <div>
            <p>6 months*</p>
            <p><strong>$700 per month</strong></p>
            <small>*3 full shoot days per month</small>
          </div>
          <div>
            <p>12 months*</p>
            <p><strong>$650 per month</strong></p>
            <small>*3 full shoot days per month</small>
          </div>
          <div>
            <h2>Daily Pricing</h2>
            <p>Full Day (8 hours)<span></span>$500</p>
            <p>Half Day (4 hours)<span></span>$250</p>
          </div>
        </Table>
      </Section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pricing.js